import {mapProfileAnalysisDataInput} from '../WorkforceProfileDetail/mapExtractedProfile';

import type {ResearchWorkforceProfileDraftResponse} from '../../../../../lib/api/RequestBodies/features/company/workforce/WorkforceProfileRequestBodies';
import {ApiSerializer} from '../../../../../serializers/ApiSerializer';

export const mapResearchWorkforceProfileDraftResponse = (raw: unknown): ResearchWorkforceProfileDraftResponse => {
  const camel = ApiSerializer.toCamelCase<Record<string, unknown>>(raw);
  const profileAnalysisDataInput =
    mapProfileAnalysisDataInput(camel.profileAnalysisDataInput as Parameters<typeof mapProfileAnalysisDataInput>[0]) ??
    (camel.profileAnalysisDataInput as ResearchWorkforceProfileDraftResponse['profileAnalysisDataInput']);

  return {
    workforceProfileResearch: (camel.workforceProfileResearch ??
      {}) as ResearchWorkforceProfileDraftResponse['workforceProfileResearch'],
    profileAnalysisDataInput,
    researchMetadata: {
      confidence: (camel.researchMetadata as {confidence?: string})?.confidence ?? null,
      sourcesSummary: (camel.researchMetadata as {sourcesSummary?: string})?.sourcesSummary ?? null,
      gapsOrAmbiguities: ((camel.researchMetadata as {gapsOrAmbiguities?: string[]})?.gapsOrAmbiguities ?? []),
    },
  };
};
